export default function Hero() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden pt-[72px]"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20flowing%20organic%20shapes%20in%20coral%20red%20and%20warm%20amber%20tones%2C%20soft%20diffused%20lighting%2C%20modern%20cinematic%20atmosphere%2C%20subtle%20geometric%20patterns%2C%20clean%20minimal%20aesthetic%20with%20depth%2C%20no%20text%20or%20logos%2C%20dark%20rich%20bottom%20area%20for%20text%20overlay%20contrast&width=1600&height=900&seq=hero-bg-bbtv-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-4 md:mb-5">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
              <span className="text-xs md:text-sm font-medium text-background-50 whitespace-nowrap">
                热播剧集 &middot; 电影大全 &middot; 免费高清
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-background-50 leading-tight">
              棒棒TV - 免费高清影视在线观看平台
            </h1>

            <p className="mt-3 md:mt-4 text-lg md:text-xl text-background-50/90 font-heading">
              随时随地，畅享海量高清影视内容
            </p>

            <p className="mt-4 md:mt-5 text-sm md:text-base text-background-50/75 leading-relaxed max-w-xl mx-auto lg:mx-0">
              棒棒TV汇集海量电视剧全集与电影大片，每日更新最新热播剧集和热门电影。无论你偏爱国产剧、韩剧、美剧还是院线大片，这里都能找到。高清画质、流畅播放、无需注册，打开即看——你的私人影视库，尽在棒棒TV。
            </p>

            <div className="mt-5 md:mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6">
              <div className="flex items-center gap-1.5">
                <span className="text-accent-400 font-heading text-lg md:text-xl">2000+</span>
                <span className="text-xs md:text-sm text-background-50/70">更新剧集</span>
              </div>
              <span className="text-background-50/30 hidden sm:block">|</span>
              <div className="flex items-center gap-1.5">
                <span className="text-accent-400 font-heading text-lg md:text-xl">1080P</span>
                <span className="text-xs md:text-sm text-background-50/70">高清画质</span>
              </div>
              <span className="text-background-50/30 hidden sm:block">|</span>
              <div className="flex items-center gap-1.5">
                <span className="text-accent-400 font-heading text-lg md:text-xl">50+</span>
                <span className="text-xs md:text-sm text-background-50/70">每日更新</span>
              </div>
            </div>

            <div className="mt-6 md:mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                onClick={(e) => { e.preventDefault(); handleClick('#media'); }}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 text-sm md:text-base font-semibold rounded-full hover:bg-primary-600 transition-all whitespace-nowrap text-center cursor-pointer"
              >
                开始观看
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); handleClick('#ranking'); }}
                className="w-full sm:w-auto px-8 py-3 bg-background-50/15 text-background-50 text-sm md:text-base font-medium rounded-full hover:bg-background-50/25 transition-all border border-background-50/25 whitespace-nowrap text-center cursor-pointer"
              >
                查看榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20abstract%20cinematic%20composition%20with%20floating%20geometric%20shapes%20representing%20entertainment%20and%20streaming%20media%2C%20warm%20coral%20and%20amber%20gradient%20tones%2C%20glowing%20light%20effects%2C%20dynamic%20flowing%20ribbons%20suggesting%20film%20reels%20and%20digital%20content%2C%20clean%20minimal%20design%20with%20depth%20and%20atmosphere%2C%20high%20contrast%20against%20dark%20background%2C%203D%20render%20style%20with%20soft%20shadows&width=800&height=600&seq=hero-visual-bbtv&orientation=landscape"
                alt="棒棒TV在线影视观看平台"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}